import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar, LineClamp } from '../../global/commonStyle';

interface Props {
  isSearchScreen?: boolean;
  isKeyboardVisible?: boolean;
}

const PopUp = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .vercel [cmdk-root] {
    width: 598px;
    background: var(--background-primary);
    border-radius: var(--border-radius-16);
    overflow: hidden;
    box-shadow: var(--modal-shadow);
    transition: transform var(--transition-fast) ease;
  }

  .vercel [cmdk-input] {
    border: none;
    width: 526px;
    ${Typography.body_lg}
    outline: none;
    color: var(--text-primary);
    border-radius: var(--border-radius-0);
    background-color: var(--background-primary);
    margin-bottom: var(--space-0);
    padding: var(--space-0);
  }

  .vercel [cmdk-input]::placeholder {
    color: var(--text-placeholder);
  }
  .record-snap-icon {
    path {
      fill: var(--text-primary);
    }
    circle {
      fill: var(--text-primary);
    }
  }
  .svg-icon {
    path {
      fill: var(--text-primary);
    }
  }
  .vercel [cmdk-vercel-badge] {
    height: 20px;
    background: var(--neutral-secondary);
    display: inline-flex;
    align-items: center;
    padding-inline: var(--space-8);
    ${Typography.body_sm_medium}
    color: var(--text-secondary);
    border-radius: var(--border-radius-4);
    margin: var(--space-4) var(--space-0) var(--space-4) var(--space-12);
    user-select: none;
    text-transform: capitalize;
  }

  .vercel [cmdk-item] {
    content-visibility: auto;
    cursor: pointer;
    border-radius: var(--border-radius-8);
    ${Typography.body_md}
    ${AlignCenter}
    gap: var(--space-8);
    padding: var(--space-6) var(--space-8);
    height: 24px;
    color: var(--text-primary);
    user-select: none;
    will-change: background, color;
    transition: all var(--transition-fast) ease;
    transition-property: none;

    span {
      color: var(--text-secondary);
    }
    ${mobile_xl(css`
      ${Typography.body_md};
      padding: var(--space-11) var(--space-12) var(--space-11) var(--space-8);
      color: var(--text-primary);
      height: unset;
      gap: var(--space-8);
      &.task-status-icon {
        align-items: flex-start;
      }
    `)}
  }

  .vercel [cmdk-item] .search-profile {
    span {
      color: var(--text-white);
    }
  }

  .vercel [cmdk-item][data-selected='true'] {
    background: var(--neutral-secondary);
    color: var(--text-primary);
    border-radius: var(--border-radius-8);
    kbd {
      color: var(--text-primary);
    }
    ${mobile_xl(css`
      background: unset;
      color: var(--text-primary);
    `)}
  }

  .vercel [cmdk-item][data-disabled='true'] {
    cursor: not-allowed;
  }

  .vercel [cmdk-item]:active {
    transition-property: background;
    background: var(--neutral-secondary);
    color: var(--text-primary);
  }

  .vercel [cmdk-item] svg {
    width: 18px;
    height: 18px;
    ${mobile_xl(css`
      width: 20px;
      height: 20px;
    `)}
  }

  .vercel [cmdk-group].projects-label [cmdk-item] svg {
    width: 13px;
    height: 13px;
    path {
      fill: var(--text-white);
    }
    ${mobile_xl(css`
      width: 16px;
      height: 16px;
    `)}
  }

  .vercel [cmdk-list] {
    height: min(330px, var(--cmdk-list-height));
    max-height: 400px;
    overscroll-behavior: contain;
    transition: var(--transition-fast) ease;
    transition-property: height;
    padding: var(--space-0) var(--space-12) var(--space-16) var(--space-12);
    ${HideScrollbar}
  }

  .vercel [cmdk-vercel-shortcuts] {
    display: flex;
    margin-left: auto;
    gap: var(--space-4);
    ${mobile_xl(css`
      display: none;
    `)}
  }

  .vercel [cmdk-vercel-shortcuts] kbd {
    ${Typography.body_sm}
    min-width: 14px;
    padding: var(--space-4);
    height: 14px;
    border-radius: var(--border-radius-4);
    color: var(--text-secondary);
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  }

  .vercel *:not([hidden]) + [cmdk-group] {
    margin-top: var(--space-12);
    .setting-label {
      margin-top: var(--space-12);
    }
    :nth-child(2) {
      margin-top: var(--space-0);
    }

    ${mobile_xl(css<Props>`
      margin-top: var(--space-24);
      display: flex;
      flex-direction: column;
      gap: var(--space-4);
      &.projects-label {
        margin-top: var(--space-0);
      }
      &.recent-searches {
        margin-bottom: var(--space-24);
      }
      :last-child {
        margin-bottom: ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'var(--space-0)' : 'var(--space-40)')};
      }
    `)}
  }
  .vercel *:not([hidden]) + [cmdk-group].setting-label {
    margin-top: var(--space-12);
  }

  .vercel [cmdk-group-items] {
    ${mobile_xl(css`
      display: flex;
      flex-direction: column;
      gap: var(--space-4);
    `)}
  }
  .vercel [cmdk-group-heading] {
    user-select: none;
    ${Typography.body_sm_medium}
    color: var(--text-secondary);
    padding-inline: var(--space-8);
    ${AlignCenter}
    margin-bottom: var(--space-4);
    ${mobile_xl(css`
      ${Typography.body_lg_semibold}
      margin-bottom: var(--space-0);
    `)}
  }

  .vercel [cmdk-empty] {
    ${Typography.body_lg}
    ${FlexCenter}
    white-space: pre-wrap;
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    width: calc(100% - 32px);
    left: 50%;
    transform: translateX(-50%);
    margin-left: -20px;
    .vercel [cmdk-root] {
      width: 100%;
    }
  `)}
  ${(props: Props) =>
    props.isSearchScreen &&
    css`
      position: relative;
      top: unset;
      left: unset !important;
      transform: unset !important;
      width: 100vw !important;
      margin-left: -16px;
      .vercel [cmdk-list] {
        height: calc(100dvh - 168px);
        max-height: calc(100dvh - 168px);
        ${HideScrollbar}
        padding: var(--space-0) var(--space-0) var(--space-16) var(--space-16);
        ${mobile_xl(css`
          padding: var(--space-12) var(--space-12) var(--space-16);
          max-height: unset;
          height: unset;
          margin-right: var(--space-0);
          overflow: unset;
        `)}
      }
      .vercel [cmdk-root] {
        width: 100%;
        background: var(--background-primary);
        border-radius: var(--border-radius-0);
        box-shadow: unset;
        ${mobile_xl(css<Props>`
          background: var(--background-secondary);
          margin-bottom: ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'var(--space-0)' : 'var(--space-40)')};
          ${HideScrollbar}
        `)}
      }
    `}
`;

const Main = styled.div`
  z-index: var(--z-index-99999);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const Tab = styled.div`
  display: flex;
  gap: var(--space-8);
  padding: var(--space-12) var(--space-20);
  button {
    padding: var(--space-2) var(--space-12);
  }
  ${mobile_xl(css`
    display: none;
    button {
      padding: var(--space-7) var(--space-14);
      ${Typography.body_md_medium}
    }
  `)}
`;

const EmptyStateDiv = styled.div`
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-12);
  padding-block: var(--space-40);
  p {
    color: var(--text-placeholder);
  }
  ${mobile_xl(css`
    padding: var(--space-0);
    height: calc(100dvh - 200px);
    img {
      display: none;
    }
  `)}
`;

const MainDiv = styled.div`
  ${FlexBetween}
  width: 100%;
`;

const Text = styled.div``;

const ClearDiv = styled.div`
  cursor: pointer;
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const SearchArea = styled.div`
  position: relative;
  padding-block: var(--space-4) var(--space-8);
  input {
    padding: var(--space-8) var(--space-40) var(--space-8) var(--space-16);
    width: -webkit-fill-available;
    outline: 0;
    background-color: var(--background-secondary);
    border: 0.5px solid var(--border-primary);
    color: var(--text-primary);
    border-radius: var(--border-radius-8);
    ${Typography.body_md}
    ::placeholder {
      color: var(--text-placeholder);
    }
    &:focus {
      border: 0.5px solid var(--brand-primary);
    }
  }
  .close-icon-responsive {
    position: absolute;
    right: 10px;
    top: 14px;
    background-color: var(--border-secondary);
    svg path {
      fill: var(--text-white);
    }
  }
`;

const WorkspaceSwitch = styled.div`
  ${FlexBetween}
  width: 100%;
  ${Typography.body_md}
  button {
    padding: var(--space-2) var(--space-8);
    background-color: unset;
    border: 1px solid var(--border-primary);
    border-radius: var(--border-radius-4);
    outline: none;
    cursor: pointer;
    ${Typography.body_sm}
    color: var(--text-secondary);
  }
`;

const IconDiv = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    padding: var(--space-2);
    &.task-status-icon {
      padding: var(--space-1) var(--space-2);
    }
  `)}
`;

const ItemDiv = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
  width: 100%;
  p {
    ${LineClamp(1)}
    text-overflow: ellipsis;
    margin: var(--space-0);
  }
  .project-name {
    display: flex;
    white-space: nowrap;
  }
  span {
    ${Typography.body_md};
  }
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-2);
    align-items: flex-start;
  `)}
`;

const ProjectName = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  ${LineClamp(1)}
  margin: var(--space-0);
  text-overflow: ellipsis;
`;

const Mark = styled.mark`
  background-color: color-mix(in srgb, var(--brand-primary) 8%, transparent);
  color: var(--brand-primary);
  border-radius: var(--border-radius-4);
  ${Typography.body_md}
  display: inline-block;
`;

const Profile = styled.div`
  width: 18px;
  height: 18px;
  ${FlexCenter}
  img {
    border-radius: var(--border-radius-full);
    object-fit: cover;
  }
  ${mobile_xl(css`
    width: 24px;
    height: 24px;
  `)}
`;

const ProjectFilterChip = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  padding: var(--space-2) var(--space-8);
  background: var(--background-primary);
  border: 1px dashed var(--border-primary);
  border-radius: var(--border-radius-8);
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  cursor: default;
  white-space: nowrap;
  .chip-close {
    ${FlexCenter}
    cursor: pointer;
    border-radius: var(--border-radius-full);
    &:hover {
      background: var(--border-primary);
    }
  }
`;

const ProjectFilterHint = styled.div`
  ${Typography.body_sm}
  color: var(--text-secondary);
  padding: var(--space-8) var(--space-8);
  .search-workspace-link {
    color: var(--brand-primary);
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export {
  PopUp,
  Main,
  Tab,
  EmptyStateDiv,
  MainDiv,
  Text,
  ClearDiv,
  SearchArea,
  WorkspaceSwitch,
  IconDiv,
  ItemDiv,
  ProjectName,
  Mark,
  Profile,
  ProjectFilterChip,
  ProjectFilterHint
};
